var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "mds-tbody",
    { staticClass: "custom-table__body" },
    _vm._l(_vm.records, function (record) {
      return _c(
        _vm.component,
        _vm._g(
          {
            key: record.id,
            tag: "component",
            attrs: { record: record, actions: _vm.actions },
          },
          _vm.$listeners
        )
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }